import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { choices } from "../config-generics/aeKao";

export const deliveryConfig: PageConfig[] = [
  {
    name: "participation",
    title: "Participation and Engagement",
    questions: [
      {
        type: "radiogroup",
        name: "successfulDelivery",
        title: "Was your project plan delivered as intended?",
        choices,
        isRequired: true,
      },
      {
        type: "comment",
        name: "unsuccessfulExplanation",
        title: "Please explain what didn't go to plan",
        placeHolder: "Ngā rerekētanga",
        visibleIf: "{successfulDelivery} = 'Kāo'",
        isRequired: true,
      },
    ],
  },
];
